var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
//@ts-nocheck
import loadable from "@loadable/component";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Switch } from "react-router-dom";
import DefaultLayout from "src/Layout";
import SimpleLayout from "src/SimpleLayout";
import { GET_CURRENT_USER } from "src/queries/users";
import { UserContext } from "src/context";
import { hasTeacherRole } from "src/utils/roles";
import { useQuery } from "@apollo/client";
import router from "src/routing/router";
import { AppRoute } from "src/routing/routes";
var StudentDashboard = loadable(function () {
    return import(
    /* webpackChunkName: 'studentDashboard' */ "src/pages/StudentDashboard");
});
var StudentOnboarding = loadable(function () {
    return import(
    /* webpackChunkName: 'studentOnboarding' */ "./pages/Onboarding/Student");
});
var TeacherDashboard = loadable(function () { return import("src/pages/TeacherDashboard"); });
var TeacherOnboarding = loadable(function () {
    return import(
    /* webpackChunkName: 'studentOnboarding' */ "./pages/Onboarding/Teacher");
});
var ProfileOnboarding = loadable(function () {
    return import(
    /* webpackChunkName: 'profileOnboarding' */ "./pages/Onboarding/Student/Profile");
});
function handleRedirect(isTeacher, onlyForTeacher, onlyForStudent) {
    if (isTeacher && onlyForStudent) {
        return true;
    }
    else if (!isTeacher && onlyForTeacher) {
        return true;
    }
    return false;
}
export default function LoggedInit() {
    var t = useTranslation().t;
    var _a = useQuery(GET_CURRENT_USER), loading = _a.loading, error = _a.error, data = _a.data;
    if (loading)
        return React.createElement("div", null);
    if (error)
        return React.createElement("p", null, t("error"));
    var user = data.me;
    var isTeacher = hasTeacherRole(user);
    var HomeComponent = null;
    var HomeLayout = SimpleLayout;
    var showOnboarding = false;
    if (isTeacher) {
        if (user.schoolSubjects.length === 0 ||
            user.avatar === null ||
            user.hasBeenReset) {
            showOnboarding = true;
            HomeComponent = TeacherOnboarding;
        }
        else {
            HomeComponent = TeacherDashboard;
            HomeLayout = DefaultLayout;
        }
    }
    else {
        if (user.schoolLevel === null ||
            user.schoolDegree === null ||
            user.hasBeenReset) {
            showOnboarding = true;
            HomeComponent = StudentOnboarding;
        }
        else if (user.avatar === null) {
            showOnboarding = true;
            HomeComponent = ProfileOnboarding;
        }
        else {
            HomeComponent = StudentDashboard;
            HomeLayout = DefaultLayout;
        }
    }
    return (React.createElement(UserContext.Provider, { value: user },
        React.createElement(Switch, null,
            Object.keys(router).map(function (key, index) {
                var _a = router[key], path = _a.path, component = _a.component, onlyForTeacher = _a.onlyForTeacher, onlyForStudent = _a.onlyForStudent, rest = __rest(_a, ["path", "component", "onlyForTeacher", "onlyForStudent"]);
                return (React.createElement(AppRoute, __assign({ key: index, path: path, showOnboarding: typeof rest.showOnboarding !== "undefined"
                        ? rest.showOnboarding
                        : showOnboarding, user: user, component: component, redirect: handleRedirect(isTeacher, onlyForTeacher, onlyForStudent) }, rest)));
            }),
            React.createElement(AppRoute, { exact: true, path: "/", user: user, layout: HomeLayout, component: HomeComponent }),
            React.createElement(Redirect, { from: "*", to: "/" }))));
}
